// PdfUploadField.jsx
import { useState } from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { UploadFile, CheckCircle } from "@mui/icons-material";
import { useAuth } from "../../../../hooks/AuthProvider";
import { MEDIA_ASSET_UPLOAD } from "../../../../config/urls";
import { ColorsConstants } from "../../../../cssUtils/constants";

const stripExtension = (fileName) => fileName.replace(/\.pdf$/i, "");

export const PdfUploadField = ({ assetKey, uploaded, onUploaded, onFileSelected, disabled }) => {
  const { getValidToken } = useAuth();
  const tenant = localStorage.getItem("tenant");
  const [stagedFile, setStagedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    setError("");
    setStagedFile(file);
    onFileSelected?.(stripExtension(file.name));
  };

  const handleConfirmUpload = async () => {
    if (!stagedFile || !assetKey) return;

    setUploading(true);
    setError("");
    try {
      const token = await getValidToken();
      const formData = new FormData();
      formData.append("asset_key", assetKey);
      formData.append("file", stagedFile);

      const response = await fetch(MEDIA_ASSET_UPLOAD, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Tenant-Id": tenant,
        },
        body: formData,
      });
      if (!response.ok) throw new Error("Upload failed");
      const data = await response.json();
      setStagedFile(null);
      onUploaded(data.asset_key);
    } catch (err) {
      setError("Could not upload PDF. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
        <Button
          component="label"
          variant="outlined"
          disabled={disabled || uploading}
          startIcon={<UploadFile />}
          sx={{ textTransform: "none" }}
        >
          {uploaded || stagedFile ? "Replace PDF" : "Upload PDF"}
          <input type="file" accept="application/pdf" hidden onChange={handleFileChange} />
        </Button>

        {stagedFile && (
          // <>
          //   <Typography sx={{ color: ColorsConstants.grayFontColor }}>
          //     {stagedFile.name}
          //   </Typography>
            <Button
              variant="contained"
              disabled={uploading}
              startIcon={uploading ? <CircularProgress size={16} /> : <CheckCircle />}
              onClick={handleConfirmUpload}
              sx={{ textTransform: "none" }}
            >
              Confirm
            </Button>
          // </>
        )}

        {uploaded && !stagedFile && !uploading && (
          <Typography
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              color: ColorsConstants.dashboardCardGreenTextColor,
            }}
          >
            <CheckCircle sx={{ fontSize: 16, mr: 0.5 }} /> Uploaded
          </Typography>
        )}
      </Stack>
      {error && (
        <Typography sx={{ color: ColorsConstants.error, mt: 0.5 }}>{error}</Typography>
      )}
    </Box>
  );
};
